import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Typography from '@mui/material/Typography';
import strings from '../../strings/strings.json'
import { runDocker, startScan } from 'api/api_service';
import * as animationData from '../../assets/animation/dockers.json'
import Lottie from 'react-lottie'
import { useHistory } from 'react-router-dom';
import { antiNameHandler } from 'module/anti_name_handler';
import Layout from 'components/layout';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

interface Props {
    location: any
}

export default function Docker(props: Props) {
    const [activeStep, setActiveStep] = useState(0)
    const history = useHistory()
    const avsData = props.location.state[0]
    const paths = props.location.state[1]

    useEffect(() => {
        renderData()
    }, [])

    const renderData = async () => {
        for (const av_name of avsData) {
            await runDocker({ "av_name": av_name })
                .then(res => {
                    if (res.status === 200) {
                        setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    }
                })
        }
        history.push({
            pathname: '/scanfile',
            state: [avsData, paths]
        })
    }

    return (
        <Layout>
            <div className='w-full h-full'>
                <div dir='rtl' className='mb-20'>
                    <div className='mt-10 mx-10 flex justify-between items-center'>
                        <span className='primary_text_color font-bold text-lg'>{strings.docker_title}</span>
                    </div>
                    <div className='grid grid-cols-2 items-center'>
                        <div className='flex items-center justify-center flex-col'>
                            <Lottie options={defaultOptions}
                                height={250}
                                width={250}
                            />
                            <span className='primary_text_color font-bold text-lg'>{strings.public_pleaseWait}</span>
                        </div>
                        <Box sx={{ maxWidth: 400 }}>
                            <Stepper activeStep={activeStep} orientation="vertical">
                                {avsData.map((step: string, index: number) => (
                                    <Step key={index}>
                                        <StepLabel
                                            optional={
                                                <Typography
                                                    variant="caption">
                                                    {activeStep > index ?
                                                        <span className='text-green-400'>{strings.public_activated}</span>
                                                        :
                                                        <span className='text-orange-400'>{strings.public_isRunning}</span>
                                                    }
                                                </Typography>}
                                        >
                                            <span className='VazirEng'>{antiNameHandler(step)}</span>
                                        </StepLabel>
                                        <StepContent>
                                            <div>
                                                <span className='secondry_text_color text-xs'>{strings.docker_activing}: </span>
                                                <span className='VazirEng'>{antiNameHandler(step)}</span>
                                            </div>
                                        </StepContent>
                                    </Step>
                                ))}
                            </Stepper>
                        </Box>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
